<ngx-loading-bar></ngx-loading-bar>
<app-royal-header [sticky]="true"></app-royal-header>
<router-outlet></router-outlet>
<app-royal-footer></app-royal-footer>
<app-tap-to-top></app-tap-to-top>
<!-- <app-layout-box></app-layout-box> -->